import { useQuery } from 'react-query';

import { type IPlaybookV2, PlaybookRunStatus } from 'src/services/api/playbooks/types';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { playbooksPath } from 'src/services/api/playbooks/path';

type IGetPlaybooksV2Response = {
    playbooks: IPlaybookV2[];
};

export const usePlaybooksV2 = () => {
    return useQuery<IPlaybookV2[]>(
        queryKeys.playbooksV2,
        async () => {
            const res = await apiClient(`${playbooksPath}?whole_team=true`).json<IGetPlaybooksV2Response>();
            return res.playbooks;
        }, {
            // refetch every two seconds while one of the latest runs is still pending
            refetchInterval(data: IPlaybookV2[] | undefined) {
                const hasPendingRun = data?.some(playbook => {
                    return [PlaybookRunStatus.RUNNING, PlaybookRunStatus.QUEUED]
                        .includes(playbook.latest_run?.status as PlaybookRunStatus);
                });

                return hasPendingRun ? 2000 : 0;
            }
        }
    );
};
